






































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import AnalysesList from "./AnalysesList.vue";
import { Farm } from "@/api/farms/types";
import { Analysis } from "@/api/analyses/types";
import * as service from "@/services/analyses";
import EventBus from "@/event-bus";
import ConfirmationModal from "@/components/confirmationModal/ConfirmationModal.vue";
import Loading from '@/components/loading/Loading.vue';
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";

@Component({
  name: "FarmViewAnalysesListController",
  components: {
    AnalysesList,
    ConfirmationModal,
    loading: Loading,
    AgroIcons,
  },
})
export default class AnalysesListController extends Vue {
  @Prop({ type: Object, required: true })
  private farm!: Farm;
  private analysesList: Analysis[] = [];
  private isLoading = false;

  private modal: boolean = false;

  private analysis: Analysis | null = null;

  private async mounted() {
    await this.loadAnalysis();
    
    EventBus.$on("new:analysis", async (farmUuid: string) => {
      if (this.farm.uuid === farmUuid) {
        await this.loadAnalysis();
      }
    });
  }

  private async loadAnalysis() {
    this.analysesList = await service.getAnalysisByFarmUuid(this.farm.uuid!);
  }

  @Emit("click:addAnalyze")
  private emitClickAddAnalysis() {}

  @Emit("click:addSentinela")
  private emitClickAddAnalysisSentinela() {}

  private getAnalysisForDelete(analysis: Analysis) {
    this.modal = true;
    this.analysis = analysis;
  }

  private closeAnalysisDelete() {
    this.modal = false;
    this.analysis = null;
  }

  private async deleteAnalysis() {
    this.isLoading = true;
    await service.deleteAnalysis(this.analysis!);
    this.closeAnalysisDelete();
    this.isLoading = false;
  }

  get analitica() {
    return this.$store.getters['user/analitica'];
  }

  get sentinela() {
    return this.$store.getters['user/sentinela'];
  }

}
